import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Menu from "./components/Menu";
import Contact from "./components/Contact";
import Wine from "./components/Wine";
import WineTasting from "./components/WineTasting";
import Vouchers from "./components/Vouchers";
import Account from "./components/Account";
import  Event from "./components/Events";
// import GroupBookings from "./components/Events";
import Cart from "./components/Cart";
import { ToastProvider } from "./components/ToastProvider";

export default function App() {
  return (
    <ToastProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/wine" element={<Wine />} />
          <Route path="/wine-tastings" element={<WineTasting />} />
          <Route path="/vouchers" element={<Vouchers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/events" element={<Event />} />
          {/* <Route path="/booking" element={<GroupBooking />} /> */}
          <Route path="/account" element={<Account />} />
          <Route path="/cart" element={<Cart />} />
          {/* No external routes here; handled via <a> in Header */}
        </Routes>
      </Router>
    </ToastProvider>
  );
}
